<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Rubrics Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar> <br>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" item-text="ay" return-object
                            @change="getCourseOff()" :items="ay_course_offering_list" label="Select AY" outlined
                            persistent-hint hint="Please Select AY" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="semester" item-text="sem"
                            item-value="id" :items="semester_list" label="Select Semester" outlined persistent-hint
                            hint="Please Select Semester" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="coff" item-text="course"
                            item-value="cof_id" :items="course_offering_list" label="Select Course" outlined
                            persistent-hint hint="Please Select Course" />
                    </v-col>
                    <v-col cols="12" sm="1" v-if="ay && semester && coff">
                        <v-btn class="button" @click="getRubricsDetailsList()">Proceed</v-btn>
                    </v-col>
                </v-row>
                <br>
                <v-row justify="center" dense v-if="show_rubrics">
                    <v-col cols="12" sm="4">
                        <b>Assessment Scheme :-</b> {{courseAssessmentScheme}}
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="rubrics" item-text="name"
                            item-value="id" :items="rubrics_list" label="Select Rubric" outlined persistent-hint
                            hint="Please Select Rubric" multiple />
                    </v-col>
                    <!-- <v-col cols="12" sm="3">
                     <v-text-field v-model="sort_order" persistent-hint rounded outlined dense label="Enter Sort Order"></v-text-field>
                </v-col> -->
                    <v-col cols="12" sm="1" v-if="rubrics.length > 0">
                        <v-btn class="button" @click="saveRubricsDetailsList()">Save</v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="box" v-if="rubrics_details_list!=''">
                <v-data-table :headers="headers" :items="rubrics_details_list">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Rubrics Details List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.sort_order`]="{ item }">
                        <v-row justify="center">
                            <v-col sm="10" md="10" cols="12">
                                <v-text-field v-model="item.sort_order" persistent-hint rounded outlined dense
                                    label="Sort Order"></v-text-field>
                            </v-col>
                            <v-col sm="2" md="2" cols="12"><v-btn rounded class="button" small :loading="loader"
                                    @click="updateSortOrder(item.id,item.sort_order)">
                                    Save
                                </v-btn></v-col>
                        </v-row>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <v-icon color="red" @click="deleteRubricsDetails(item)">mdi-trash-can</v-icon>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
    </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
      loader:false,
        snackbar_msg: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      overlay: false,
      headers:[
      { text: "SR No", value: "count" },
      { text: "Rubrics", value: "rubric" },
      { text: "Assessment Scheme", value: "courseassessmentscheme" },
      { text: "Sort Order", value: "sort_order", width: 500 },
      { text: "Delete", value: "delete" },
      ],
      ay_list:[],course_offering_list:[],semester_list:[],ay:"",coff:"",semester:"",rubrics_details_list:[],show_rubrics:false,
      rubrics_list:[],rubrics:[],courseAssessmentScheme:"",courseAssessmentScheme_id:"",sort_order:0,ay_course_offering_list:[],
  }),
   methods: {
    cleardata(){
        this.coff="",this.semester="",this.show_rubrics=false,this.rubrics=[],this.courseAssessmentScheme="",this.courseAssessmentScheme_id="",this.sort_order=0
    },
     async updateSortOrder(item,sort_order) {
            if(sort_order<0){
                 this.showSnackbar("red", "Sort Order Cannot Be Negative..");
                 return
            }
            this.overlay = true;
            this.loader = true;
             const data = {
                rubrics_details_id:item,
                sort_order:sort_order
             };
            try {
                const res = await axios.post("/WWSExamination/updateSortOrder",data)
                if (res.data.flag == "YES") {
                      this.showSnackbar("green", "Updated Successfully...");
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
                this.loader = false;
            }
            finally {
                this.getRubricsDetailsList()
                this.overlay = false;
                this.loader = false;
            }

        },
     async deleteRubricsDetails(item) {
         if (!confirm("are you sure to delete!")) return;
            this.overlay = true;
             const data = {
                rubrics_details_id:item.id,
             };
            try {
                const res = await axios.post("/WWSExamination/deleteRubricsDetails",data)
                if (res.data.flag == "YES") {
                    // this.rubrics_details_list = res.data.rubrics_details_list
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                this.getRubricsDetailsList()
                this.overlay = false;
            }

        },
     async saveRubricsDetailsList() {
            this.rubrics_details_list=[]
            this.overlay = true;
             const data = {
                     rubrics:this.rubrics,
                     courseAssessmentScheme_id:this.courseAssessmentScheme_id,
                    //  sort_order:this.sort_order
             };
            try {
                const res = await axios.post("/WWSExamination/saveRubricsDetailsList",data)
                if (res.data.flag == "YES") {
                    this.rubrics_details_list = res.data.rubrics_details_list
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                this.cleardata()
                this.overlay = false;
            }

        },
     async getRubricsDetailsList() {
            this.rubrics_details_list=[]
            this.overlay = true;
             const data = {
                     ay:this.ay.ay_id,
                     semester:this.semester,
                     coff:this.coff,
             };
            try {
                const res = await axios.post("/WWSExamination/getRubricsDetailsList",data)
                if (res.data.flag == "YES") {
                    this.show_rubrics=true
                    this.rubrics_details_list = res.data.rubrics_details_list,
                    this.courseAssessmentScheme=res.data.courseAssessmentScheme
                    this.courseAssessmentScheme_id=res.data.courseAssessmentScheme_id
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }

        },
        getCourseOff(){
            this.course_offering_list=[]
            this.course_offering_list = this.ay.course_offering_list
        },
     async onLoad() {
            this.overlay = true;
            try {
                const res = await axios.post("/WWSExamination/getRubricsDetails")
                if (res.data.flag == "YES") {
                    this.ay_list = res.data.ay_list
                    this.ay_course_offering_list = res.data.ay_course_offering_list
                    this.rubrics_list = res.data.rubrics_list
                    this.semester_list = res.data.semester_list
                  //  this.course_offering_list = res.data.course_offering_list
                   // this.ay = res.data.cay
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }

        },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>